import React, { useEffect, useState } from "react";
import { DashboardManagerFilter } from "../../../model/dashboard-manger-filter";
import { BaseList } from "../../../../../component/list/base-list";
import { CohortStudentModuleAverageRating } from "../../../model/cohort-student-module-average-rating";
import { columns } from "./cohort-student-module-average-rating-list-column-definition";
import { getCohortModuleAverageRatings } from "../../../service/dashboard-manager-service";
import BaseOperations from "../../../../../component/operations/base-operations";

const storageKey = "DASHBOARD_MANAGER_MODULE_AVERAGE_RATING"

export default function CohortStudentModuleAverageRatingList({
    filter,
    setFilter
}: {
    filter: DashboardManagerFilter,
    setFilter: React.Dispatch<React.SetStateAction<DashboardManagerFilter>>,
}) {
    const [loading, setLoading] = useState(false);
    const [averageRatings, setAverageRatings] = useState<CohortStudentModuleAverageRating[]>([]);

    useEffect(() => {
        if (filter.cohortId !== undefined) {
            setLoading(true);
            getCohortModuleAverageRatings(
                filter.cohortId,
                Number(filter.moduleId) !== 0 ? filter.moduleId : undefined,
                filter.studentId !== 0 ? filter.studentId : undefined
            ).then(result => {
                setAverageRatings(result);
                setLoading(false);
            });
        } else {
            setAverageRatings([]);
        }
    }, [filter]);

    return (
        <React.Fragment>
            <BaseList
                storageKey={storageKey}
                style={{ marginBottom: "1.5rem" }}
                rows={averageRatings}
                columns={columns}
                loading={loading}
                localeText={{ noRowsLabel: "No module average ratings" }}
                getRowId={(row) => `${row?.cohortId}-${row?.moduleId}-${row?.studentId}`}
                disableRowSelectionOnClick={false}
                onRowClick={(e) => setFilter({ ...filter, moduleId: e.row?.moduleId, studentId: e.row?.studentId })}
                exportName={`${storageKey}_${filter.cohortId}`}
            />
            {averageRatings?.length > 0 && <BaseOperations
                helpInfoTexts={[
                    "You can click on a row in the list to select the <b>Module</b> and <b>Student</b>.",
                    "The average rating is given by <b>summarizing badge rating</b> and divide by the <b>number of badges</b> for the module."
                ]}
            />}
        </React.Fragment>
    );
}
